import { isResponseWithData } from 'lib-shared-auth';
import { Role } from 'lib-shared-user-role';
import { useMount } from 'react-use';
import { getFormValues } from 'redux-form';

import { usersApi } from 'apis/users';
import { userModalFormName } from 'components/usersModal/userModal.actions';
import { UserModalState } from 'components/usersModal/userModal.reducer';
import {
  selectUserModal,
  selectUserModalInitialValues,
} from 'components/usersModal/userModal.selectors';
import { UserModalFormData } from 'components/usersModal/userModal.types';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

type UseInitializeRolesFieldValueArg = (roles: Role[]) => void;

export const useInitializeRolesFieldValue = (
  onInit: UseInitializeRolesFieldValueArg,
): void => {
  const dispatch = useAppDispatch();
  const { userId } = useAppSelector<UserModalState>(selectUserModal);
  const initialValues = useAppSelector<UserModalFormData>(
    selectUserModalInitialValues,
  );
  const formValues = useAppSelector<UserModalFormData | undefined>(
    getFormValues(userModalFormName),
  );

  // Sets the initial custom_roles form value to the user's roles when editing member users.
  useMount(() => {
    if (!userId || initialValues.user_type !== 'member') return;

    const fetchUserRoles = async () => {
      const response = await dispatch(
        usersApi.endpoints.readUserRoles.initiate(
          { userId },
          { forceRefetch: true },
        ),
      );

      if (isResponseWithData(response)) {
        const roles = response.data.data.roles_with_scopes.map(
          ({ role }) => role,
        );

        if (roles && !formValues?.custom_roles?.length) {
          onInit(roles);
        }
      }
    };

    fetchUserRoles();
  });
};
